import { Api } from "../utils/generated/api"
import { useTokenCookie } from "./local/token-cookie"

export const useApi = defineStore("api", () => {
	const config = useRuntimeConfig()
	const token = useTokenCookie()
	const api = new Api({
		customFetch,
		baseUrl: config.public.server.address,
	})

	async function customFetch(input: RequestInfo | URL, init: RequestInit | undefined) {
		const tokenValue = token.getCookie()

		init ??= {}
		init.headers ??= {}

		if (tokenValue) {
			init.headers = {
				...init.headers,
				authorization: tokenValue,
			}
		}

		const response = await fetch(input, init)
		return response
	}

	return api
})
